// extracted by mini-css-extract-plugin
export default {"featureIcon":"FeatureCard_featureIcon__eJVFU"};